import { MERCHANT_DEVICE_TYPE, constants } from '../../Constants/constants'
import { standardizeOptions } from '../../helper/util'
import { ICONIFY } from '../../Constants/iconify'

import ModernIconUrl from '../../assets/icon/android_modern.png'
import LegacyIconUrl from '../../assets/icon/android_legacy.png'

const resource = 'appVersionPage'

export const DEVICE_TYPE = [
                {
                    value: 'PR',
                    label: 'PR',
                },
                {
                    value: 'KIOSK',
                    label: 'KIOSK',
                },
                {
                    value: 'TV',
                    label: 'TV',
                },
            ];

export const appVersionListFilters = [
    {
      className: 'filter-input',
      label: { resource: resource, key: 'appVersion' },
      clear: true,
      value: '',
      name: 'appVersion',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'buildNumber' },
      clear: true,
      value: '',
      name: 'buildNumber',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'customCode' },
      clear: true,
      value: '',
      name: 'customCode',
      size: constants.SIZE.SMALL,
    },
    // {
    //   className: 'filter-input',
    //   label: { resource: resource, key: 'buildTarget' },
    //   value: '',
    //   type: constants.TYPE.SELECT,
    //   selectValue: standardizeOptions(constants.CHOICES.APP_VERSION.BUILD_TARGET, 'value', 'name'),
    //   name: 'buildTarget',
    //   size: constants.SIZE.SMALL,
    //   disabled: true,
    // },
    // {
    //   className: 'filter-input',
    //   label: { resource: resource, key: 'status' },
    //   value: '',
    //   type: constants.TYPE.SELECT,
    //   selectValue: constants.CHOICES.APP_VERSION.STATUS,
    //   name: 'statusList',
    //   size: constants.SIZE.SMALL,
    //   disabled: true,
    // },
  ]

export const chipRender = (type) => {
      let chip = null

      switch (type) {
        case 'ANDROID_MODERN':
        case 'androidModern':
          chip = {
            // icon: ICONIFY.target,
            icon: ModernIconUrl,
            color: 'primary',
          }
          break;
        
        case 'ANDROID_LEGACY':
        case 'androidLegacy':
          chip = {
            // icon: ICONIFY.history,
            icon: LegacyIconUrl,
            color: 'success',
          }
          break;

        case 'ANDROID_MPOS':
        case 'androidMpos':
          chip = {
            icon: ICONIFY.mpos,
            color: 'warning',
          }
          break;

        case 'IOS':
        case 'ios':
          chip = {
            icon: ICONIFY.apple,
            color: 'pending',
          }
          break;
      
        default:
          break;
      }

      return chip
    }